<template>
<div>

  <section  class="navbarsection" style="margin-top: -80px;">
    <div class="txtdata">
      <h1  style="padding-top: 200px;"></h1>
    </div>
      <div class="videosection" >
        <div  v-show="pvisvideo === true && pvpictureimage === false ">
          <Transition class="transition thing">
            <video-background 
              playbackRate=0.9
              :src="src"
              :poster="poster"
              :class="`thing playercss`"
              :style="`height: 600px;`">
            </video-background>
          </Transition>
        </div>
      
          <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px; z-index: 1;`">
          </div>

          <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
          v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
 
    </div>
    <div class="overlay"></div>
    <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px; ">
      <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
    </div>
  </section>

<!-- <div style="height: 10px;  background-image: linear-gradient(white, #003 99%); margin-top: -200px; z-index: 9999;">

</div> -->
 
  <StockCards :getstocks="getstocks" stocktheme="stockcss"/>

  <section>
    <div class="container divsec1" v-for="ghp in gethomepagesecone" data-aos="fade-up">
      <p v-html="ghp.hp2desc" data-aos="fade-up"></p>
      <!-- <div class="learnmoreghp" align="right" data-aos="fade-up"><router-link :to="{path: ghp.linkhref}" class="learnmoreghp"> {{ ghp.linktext}}<i class="fa-solid fa-angles-right"></i> </router-link></div> -->
    </div>
  </section>

 <!-- <AllNews :homepagenews="homepagenews" :newsphoto="newsphoto" /> -->

 <AllCards :cvdesc="cvdesc" :valuesphotos="valuesphotos" :cvpurposevaluelinkname="cvpurposevaluelinkname" :cvlink="cvlink" />

  <section class="valuecreationimage">
    <img :src="`${cvimagepath}`" class="cvvalueimage" style="width: 100%; margin: 0 auto;">
  </section>

  <div class="tabcards">
    <TabsandTextcards :allcodes="allcodes" :allcodesdetails="allcodedetails" :getdtsInfo="getdtsInfo" @click.prevent="getdtsId($event)" :getfirstid="allcodedetails" />
  </div>


<!-- <section class="tabsection">
  <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
    :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
    :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" reportpresenttheme="reportpresentcss"/>
</section> -->
<section class="allslidesection">
  <AllSlides :displayedPhotos="displayedPhotos" :ophotos="ophotos" :page="page" :perPage="perPage" :pages="pages" :totalPages="totalPages"  />
</section>

</div>
</template>

<script>
import AllNews from '@/components/AllNews.vue';
import AllCards from '@/components/AllCards.vue';
import AllReports from '@/components/AllReports.vue';
import StockCards from '@/components/StockCards.vue';
import TabsandTextcards from '@/components/TabsandTextcards';
// import {Swiper, SwiperSlide} from 'swiper/vue';
import axios from 'axios';
import AllSlides from '@/components/AllSlides.vue';


import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
require('@/globalDeclare.js');

export default {
  name: 'HomeView',
  components: {
  AllSlides, AllNews, AllCards, AllReports, StockCards, TabsandTextcards
},

data() {
  return {
    getstocks: [],
    gethomepagesecone: [],
    homepagenews: [],
    newsphotos: [],
    newsphoto: '',
    valuesphotos: [],
    creatingvalues: [],
    // cvpurposevalue: '',
    // cvpurposevaluelinkname: '',
    cvimagepath: '',
    cvlink: '',
    cvdesc: '',
    // valuelisting1: [],
    allcodes: [],
    allcodedetails: [],
    valuelisting2: [],
    valueid: 0,
    // cv2desc: '',

  carouselSlides: [],
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  pictureimage: '',
  picurl: myUrlPath,

    //pagination props
    ophotos: [],
    page: 1,
    perPage: 1,
    pages: [],
    totalPages: 0,
    displayedPhotos: [],

    openpdf: '',
    openlistreport: '',
    getdtsInfo: '',
    getfirstid: '',
    allcodesingle: '',

    reportpresentation: [],
    reportcnt: '',
    lastrecordsreportpresent: [],
    rppdfpath: '',
    rptitle: '',
    rpdate: '',
    rplinkname: '',
    rptfulltext: '',
    rpcoverpageimagepath: '',
    singlereporttitle: '',
    rplinkname: '',
    rpdate: '',

  }
},

setup() {

},
mounted(){

  axios.get('allpagespv/homepage').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })


  axios.get('homepageotheruploadlisting/').then(
      response => {
        this.carouselSlides = response.data
        console.log(this.carouselslides)
    })
    .catch((error) => {
        console.log(error)
      })

      //------------Homepage Stock Prices---------------
    axios.get('stockprices/homepage').then(
      response => {
          this.getstocks = response.data
    })
    .catch((error) => {
        console.log(error)
      })

    //------------Home Page Section One
  axios.get('homepagesecone/').then(
      response => {
          this.gethomepagesecone = response.data
    })
    .catch((error) => {
        console.log(error)
      })

  //-----------Homepage News section-------------
  axios.get('homepagenewslisting/').then(
      response => {
          this.homepagenews = response.data.results
    })
    .catch((error) => {
        console.log(error)
      })

  //-----------Homepage NewsPhoto section-------------
  axios.get('newsphotos/').then(
      response => {
          this.newsphotos = response.data
          this.newsphoto = response.data[0]['newsphoto']
    })
    .catch((error) => {
        console.log(error)
      })


    //-----------Homepage Values Photos section-------------
  axios.get('valuesphotos/homepage').then(
      response => {
          this.valuesphotos = response.data
    })
    .catch((error) => {
        console.log(error)
      })
    //-----------Homepage Values section-------------
  axios.get('creatingvaluelisting/').then(
    response => {
      //const this.creatingvalues = response.data[0]
      const purposeval = response.data[0]['cvpurposevalue']
      let cvdesc1 = response.data[0]['cvdesc']
      let cvimagepathval = response.data[0]['cvimagepath']
      let cvlinkval = response.data[0]['cvlink']
      let cvpurposevaluelinknameval = response.data[0]['cvlinkname']
      this.cvpurposevalue = purposeval;
      this.cvpurposevaluelinkname = cvpurposevaluelinknameval;
      this.cvimagepath = cvimagepathval;
      this.cvdesc = cvdesc1;
      this.cvlink = cvlinkval
   })
   .catch((error) => {
        console.log(error)
      })

   //-----------All codes -------------
  axios.get('getallcodes/portfolio').then(
      response => {
        this.allcodes = response.data
    })
    .catch((error) => {
        console.log(error)
      })

    //-----------All codes Single -------------
   axios.get(`getallcodes/portfolio`).then(
      response => {
        this.allcodesingle = response.data[0].oportid
        console.log(this.allcodesingle)
        
        axios.get(`getallcodesdetails/${this.allcodesingle}`).then(
          response => {
            this.allcodedetails = response.data[0].portdetails
              console.log(response.data)
          })
          .catch((error) => {
              console.log(error)
            })
          })
    .catch((error) => {
        console.log(error)
      })

  //------------Get Reports---------------
  axios.get('reportpresentationlisting/homepage').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })



  },

  methods: {
    getdtsId(event) {
      let diid = parseInt(event.target.value)
      console.log(diid)
      axios.get(`getallcodesdetails/${diid}`).then(
      response => {
        this.getdtsInfo = response.data[0].portdetails
    })
    .catch((error) => {
        console.log(error)
      })
    },


    getvalue2Id(value) {
      var valueid1 = parseInt(value.cv1id);
    axios.get(`creatingvalue2single/${valueid1}`).then(
        response => {
            var cv2desctext = response.data.cv2desc
            this.cv2desc = cv2desctext
      })
      .catch((error) => {
        console.log(error)
      })
      },
      clearvHTMLDiv(){
        $('vHTMLDiv').value("");
      },

    getPhotos() {
        axios.get('homepageotheruploadlisting/homepage').then(
             response => {
              this.ophotos = response.data;
              this.totalPages = response.data.length;
            })
            .catch(response => {
                console.log(response);
            });
        },
  },
    created() {
        this.getPhotos();
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/layout.css";
.navigate {
  margin-top: 300px;
}
.newsphotoimage{
  width: 100%;
  height: 400px;

}
.newscards {
  margin-top: 10px;
}

.reportpresentcards {
  height: 120px;
  margin-top: 10px;
}
.divsec1 {
  margin: 0 auto;
  width: 60%;
  font-size: 24px;
  color: #003;
}

.cvpurpose {
  text-align: center; 
  padding-bottom: 50px; 
  color: white; 
  font-size: 20px;
}

.cvvalueimage {
  width: 100%; 
  height: 100%; 
  position: absolute;
}

.sectiontwopurpose {
  text-align: center; 
  margin-bottom: 30px; 
  height: 50px;
}
.sectiontwolinkname {
  text-align: center; 
  padding-top: 50px; 
  height: 50px;
}

.cardgroupvalue {
  width: 60%; 
  margin: 0 auto;
}

.valuecardshref {
  text-decoration: none;
}

.valuecardsdesc {
  text-align: center;
}

.valuecardslinkname {
  text-align: center; 
  color: white; 
  font-size: 14px; 
  position: relative; 
  float: right;
}
.sectiononetwogif {
  height: 140px;
}

.sectiontwocontainer {
  padding-top: -100px;
}

.sectiontwoimagediv {
  border-right: solid thin grey; 
  float: left;
}

.sectiontwoimage {
  padding-right: 20px; 
  width: 400px;
}

.sectiontworptitlediv {
  float: left; 
  margin-top: 200px; 
  padding-left: 20px; 
  font-weight: bold; 
  font-size: 20px;
}
.sectiontwothree {
  height: 40px;
}

.reportpresentcardsgif {
  text-align: center; 
  padding-top: 50px; 
  height: 50px;
}
/*------------SECTION CAROUSELSLIDE----------*/
.sectioncarouselslide {
  height: 500px; 
  background-color: #ebf5fb; 
  margin-top: 100px;
}
.seccarouselimage {
  width: 100%; 
  float: right; 
  margin-top: -70px; 
  margin-right: 20px; 
  border-radius: 5px; 
  height: 56%;
}
.rptlink{
  color: white;
}
.carouselphotodesc {
  margin-bottom: 50px; 
  font-weight: bold; 
  font-size: 26px; 
  color: maroon;
}
.carousellinktextdiv {
  width: 300px; 
  background-color: #f9ebea; 
  position: absolute; 
  height: 180px; 
  margin-top: 300px; 
  border-radius: 5px;
}
.carouselrow {
  height: 100%;
}
.carouselcol5 {
  margin-top: -60px;
}
.carousellinktext {
  text-align: center; 
  padding-left: 10px; 
  padding-right: 10px; 
  margin-top:30px; 
  margin-bottom: 10px;
}
.sectioncarouselfootergif {
  height: 10px; 
  padding-top: 200px;
}
.allslidesection {
 background-color: rgb(233, 233, 238);
 color: #003;
 padding-top: 100px;
}
/* -------------SECTION FOOTER -----------------*/
.sectionfooter {
  margin-top: 10px
}

.cv2desc {
  color: white; 
  padding-top: 50px; 
  margin: 0 auto; 
  max-width: 700px; 
  font-size: 18px;
}
.iconsize {
  width: 40%;
  height: 40%;
  margin-top: 20px;
}

.learnmoreghp{
  text-align: right;
  text-decoration: none;
  font-size: 28px;
  color:  #935116;
}

.newslearnmore {
  text-decoration: none;
  float: right;
  font-size: 18px;
  padding-right: 50px;
  color: #003;
}
.fa-readme {
  font-size: 30px;
  padding-top: 40px;
  padding-left: 10px;
}

.valuecreationimage {
  height: 600px;
  z-index: -1000;
}

.valuecards {
  margin-right: 20px; 
  border-radius: 5px; 
  width: 150px;
}
#oddnewsbg {
  background-color:  #ebf5fb ;
  color: #003;
  font-weight: bold;
}

#evennewsbg {
  color: orange;
  font-weight: bold;
}

.textcontainer {
  width: 100%; /* Can be in percentage also. */
  height: auto;
  padding: 10px;
  position: absolute;
  color: white;
  text-align: right;
  padding-right: 200px;
}
.imglog0 {
text-decoration: none;
}

.servicescards {
  background-image: url("../assets/slide-5.jpg");
  color: white;
}


.pushcardup {
  margin-top: -200px;
  margin-left: 200px;
  height: 300px;
  z-index: 1;
  background-image: url("../assets/slide-5.jpg");
  color: white;
}
.card-header {
  background-color: white;
  color: #003;
  font-weight: bold;
  text-align: center;
}

.newscardheader {
  background-image: url("../assets/slide-5.jpg");
  color: white;
  font-size: 24px;
}


.videosection {
  margin-top: -60px;
}

.transition {
  transition: all 3s ease-out;
  animation: fadeInAnimation ease 3s;
  animation-iteration-count: 1;
  animation-fill-mode: backwards;
}

.container {
  padding-bottom: 50px;
  padding-top: 50px;
}

.services {
  background-color: #F5F5F5;
  ;
}

.navbarsection  {
  background-image: url("../assets/slide-5.jpg"); /* The image used */
  background-repeat: repeat;
  background-attachment: fixed;
}
/* Slider CSS */
.sectioncontrol{
  opacity: .9;
  padding-top: 100px;
  padding-bottom: 100px;
  height: auto;
}
.swiper {
  width: 100%;
  height: 30%;
  margin-top: -20px;
}

.cardref {
  text-decoration: none;
  color: white;
  text-align: center;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 40%;
  object-fit: cover;
  display: block;
}

.swiper-container {
  position:relative;
  width: 100vw;
  height: 300px;
}

.swiper-slide {
width: 100%;
height: 300px;
display:flex;
background: #eee;
align-items: center;
justify-content:center;
transition:all 300ms linear;
transform: scale(1);

&.swiper-slide-active{
  transform: scale(1);
  /*background: #fc0*/
}
}

.swiper-slide__content {
height: 400px;
}
main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.txtauthor {
  color: red;
  font-weight: bold;
  z-index: 1000;
}

.sectiontwo {
 margin-bottom: 100px;
 background-color: #f9ebea;
}

.transition {
  transition: all 3s ease-out;
  animation: fadeInAnimation ease 3s;
  animation-iteration-count: 1;
  animation-fill-mode: backwards;
}
.allslidesection {
  margin-bottom: -9.5px;
  
}
.stockcss {
  width: 60%;
  margin-top: -360px;
}
@keyframes fadeInAnimation {
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}



 .playercss {
  max-height: 300%; 
  height: 70vh;
 }

 .maintext {
  color: white; 
  margin-top: 400px;
  padding-left: 300px;
 }

 .thing {
  transition-timing-function: ease;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* ----------------SLIDE SHOW-------------------------------*/
.carousel{
  position: relative;
  max-height: 100vh;
  height: 90vh;
  width: 100%;
}
.slide-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 100%;
  height: 90%;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
.slidecontentinfo {
  top: -300px;
  position: relative;
  width: 60%;
  text-align: center;
  background-color: #003;
  margin: auto;
  opacity: 0.6;
  border-radius: 5px;
  border-top: solid 12px dodgerblue;
  height: 100px;
  color: white;
  line-height: 2;
  font-size: large;
 
}

[data-aos="new-animation"] {
  opacity: 0;
  transition-property: transform, opacity;
}
.tabsection {
  padding-top: 100px;
  padding-bottom: 100px;
}
@media (min-width: 325px) and (max-width: 550px) {
  .cvvalueimage{
    width: 100%;
  }
  .valuecreationimage {
    width: 100%;
  }
  .stockcss {
    width: 100%;
    padding-left: 30px;
  }

  .rainbow-text {
    margin-left: 0px;
    padding-left: -40px;
  }
  .reportpresentcss {
    margin-top: 100px;
    padding-bottom: 100px;
  }

}

 /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .divsec1{
    width: 100%;
    text-align: justify;
    padding: 30px;
    font-size: 18px;
   }
   .learnmoreghp {
    font-size: 18px;
   }
   .cvvalueimage{
    width: 100%;
   }
   .cvpurpose{
    margin-top: -20px;
   }
   .valueinnerdiv{
    width: 100%;
    margin-top: 10px;;
    height: auto;
    padding-bottom: 20px;
   }
   .valuecards{
    width: 100%;
    float: left;
   }
   .cardgroupvalue{
    margin-top: -30px;
    width: 100%;
   }
   .valuecardsdesc{
    font-size: 14px;
    font-weight: bold;
   }
   .valuecreationimage{
    margin-top: -50px;
   }

  .stockcss {
    width: 90%;
    margin: 20px;

  }
 
 }


 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

   .stockcss {
    width: 100%;
    margin: 0 auto;
    padding: 20px;   
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .divsec1{
    width: 100%;
    text-align: justify;
    padding: 30px;
   }
   .cvvalueimage{
    width: 100%;
   }
   .cvpurpose{
    margin-top: -20px;
   }
   .valueinnerdiv{
    width: 100%;
    margin-top: 10px;;
    height: 400px;
   }
   .valuecards{
    width: 100%;
    float: left;
   }
   .cardgroupvalue{
    margin-top: -30px;
    width: 100%;
   }
   .valuecardsdesc{
    font-size: 14px;
    font-weight: bold;
   }

   .stockcss {
    width: 70%;
    margin: 0 auto;
  }
  .reportpresentcss {
    margin-top: 700px;
    padding-bottom: 100px;
  }

 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
.stockcss {
  margin-top: -90px;
}

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  .reportpresentcss {
    margin-top: 200px;
    padding-bottom: 100px;
  }

  .allslidesection {
    padding-right: 100px;
    padding-left: 100px;
  }

  } 
</style>